<template>
  <div class="nx-clipping-form-board-selector input-group">
    <nx-clipping-form-selector
        :label="label"
        v-bind="$attrs"
        v-on="$listeners"
        @input="input"
    ></nx-clipping-form-selector>
  </div>
</template>

<script>
import NxClippingFormSelector from './Selector';

export default {
  name: 'nx-clipping-form-board-selector',
  components: { NxClippingFormSelector },
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="stylus">
.nx-clipping-form-selector-wrapper {
  width: 100%
  .nx-clipping-form-selector {
    width: 100%
    text-align: center
    .nx-image {
      margin: 0 auto
    }
  }
}
</style>
